"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listTags = void 0;
const listTags = ({ httpClient, }) => ({ page = 1, per_page = 25, }) => {
    const path = '/tags';
    const query_params = { page, per_page };
    const url = `${path}`;
    return httpClient.get(url, { params: query_params });
};
exports.listTags = listTags;
//# sourceMappingURL=list-tags.js.map